'use strict';

var React = require('react');

const useRefAndForward = (initialValue, forwardedRef) => {
    const ref = React.useRef(initialValue);
    React.useImperativeHandle(forwardedRef, () => ref.current);
    return ref;
};

exports.useRefAndForward = useRefAndForward;
//# sourceMappingURL=useRefAndForward.js.map
